import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  pageContainer: {
    maxWidth: '100%',
    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
      width: '100%'
    },
    '& .MuiContainer-root': {
      maxWidth: '100%'
    }
  },
  rightAlign: {
    width: '100%',
    textAlign: 'right'
  },
  filter: {
    padding: '8px 16px',
    backgroundColor: palette.common.white,
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  filterWrapper: {
    display: 'flex',
    margin: '0 -10px',
    alignItems: 'center'
  },
  filterItem: {
    width: '25%',
    padding: '10px',
    '& > div': {
      display: 'block'
    },
    '&:last-child': {
      width: '50%',
      '&.batchQueue': {
        width: '25%',
        display: 'flex',
        alignItems: 'center',
        '& .MuiIconButton-root': {
          marginLeft: '4px'
        }
      }
    },
    '& .react-datepicker-wrapper': {
      display: 'block',
      '& .MuiFormControl-root': {
        display: 'flex'
      }
    },
    '& .MuiInputBase-root': {
      width: '100%'
    }
  },
  table: {
    '& .MuiDataGrid-main': {
      maxHeight: 'calc(100vh - 348px)'
    },
    '& .MuiDataGrid-virtualScroller': {
      minHeight: '55px',
      '& .MuiDataGrid-row': {
        cursor: 'pointer'
      }
    }
  }
}));
export default useStyles;